// extracted by mini-css-extract-plugin
export var avatarContainer = "_bv-0";
export var avatarTypingWave = "_bv-i";
export var gray = "_bv-f";
export var green = "_bv-c";
export var icon = "_bv-9";
export var image = "_bv-1";
export var lg = "_bv-6";
export var md = "_bv-5";
export var presenceDot = "_bv-b";
export var red = "_bv-d";
export var sm = "_bv-4";
export var status = "_bv-a";
export var typingDot = "_bv-h";
export var typingPill = "_bv-g";
export var xl = "_bv-7";
export var xs = "_bv-3";
export var xxl = "_bv-8";
export var xxs = "_bv-2";
export var yellow = "_bv-e";